<script>
export default {
  data: () => ({
    batchSummaries: [],
  }),
  methods: {
    onSummariesLoaded(summaries) {
      this.batchSummaries = summaries;
    },
  },
}
</script>

<template>
  <api-loader
    method="get"
    url="v1/layers/batch-summaries"
    @loaded="onSummariesLoaded">

    <router-link v-for="batch in batchSummaries" :key="batch.id"
      :to="{name: 'show-layer-batch', params:{batchName:String(batch.name)}}"
      class="mb-2 clickable"
      tag="b-card"
      variant="primary">

      <h4>Batch {{batch.name}}</h4>

      <div title="Placed Date">{{batch.placed_date | formatDate('YYYY-MM-DD')}} ({{batch.age_in_weeks}} weeks)</div>

    </router-link>

  </api-loader>
</template>



// WEBPACK FOOTER //
// src/layer/components/Batches.vue